import React from 'react';

const AuthenticatedLayout = ({ children }) => {
  return (
    <main className="main-content flex flex-col flex-1">
      {children}
    </main>
  );
};

export default AuthenticatedLayout;
